// Copyright (c) 2022 by Move Closer

import { PropType } from '@vue/composition-api'
import { RawLocation } from 'vue-router'

import { ComponentObjectPropsOptions } from '../../vue-api'

import { BreadcrumbItem, BreadcrumbItemProps, BreadcrumbsProps } from './Breadcrumbs.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const breadcrumbsProps: ComponentObjectPropsOptions<BreadcrumbsProps> = {
  /**
   * @see BreadcrumbsProps.items
   */
  items: {
    type: Array as PropType<BreadcrumbItem[]>,
    required: true
  },

  /**
   * @see BreadcrumbsProps.showOnMobile
   */
  showOnMobile: {
    type: Boolean,
    required: false,
    default: false
  },

  /**
   * @see BreadcrumbsProps.root
   */
  root: {
    type: Object as PropType<BreadcrumbItem>,
    required: true
  }
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const breadcrumbItemProps: ComponentObjectPropsOptions<BreadcrumbItemProps> = {
  active: {
    type: Boolean,
    required: false,
    default: true
  },

  isExternal: {
    type: Boolean,
    required: false,
    default: false
  },

  label: {
    type: String,
    required: true
  },

  target: {
    type: [String, Object] as PropType<RawLocation>,
    required: true
  },

  metaPosition: {
    type: Number,
    required: false,
    default: null
  }
}
